<agpr-take-over-panel
    [id]="id"
    header="Mention.workbench.header"
    [overlayContainer]="overlayContainer"
    [animationTrigger]="animationTrigger"
    [hideSlideOverlay]="hideSlideOverlay"
    (visibleChange)="close($event)"
    [width]="takeOverWidth"
    (closeTakeover)="close(false)"
>
    <div class="agpr-mentionWorkbenchDialog">
        <div class="agpr-mentionWorkbenchDialog-content">
            <div
                class="agpr-mentionWorkbenchDialog-workbenchTabs"
            >
                <agpr-tabs
                    [selectedTabIndex]="selectedMentionWorkbenchTabIndex"
                    (tabChange)="workbenchTabChange($event)"
                    (selectedTabIndexChange)="workbenchTabIndexChange($event)"
                    [useContentContainer]="false"
                    [tabsHeadingLevel]="2"
                >
                    <agpr-tab
                        [id]="mentionWorkbenchTabIds.EDIT_MENTION"
                        [icon]="originalMention ? 'fa-regular fa-duotone fa-pen' : 'fa-regular fa-duotone fa-square-plus'"
                        [heading]="originalMention ? 'Mention.workbench.tabs.editMention' : 'Mention.workbench.tabs.createMention'"
                        [disabled]="isUnsavedMention"
                        [tooltip]="isUnsavedMention ? 'Mention.workbench.tabs.editMention.disabled' : ''"
                    >
                    </agpr-tab>
                    <agpr-tab
                        *ngIf="!isResellerAccount"
                        [id]="mentionWorkbenchTabIds.INSIGHTS"
                        [icon]="'fa-kit-duotone fa-agpr-insights'"
                        [heading]="'Mention.workbench.tabs.insights'"
                        [disabled]="!originalMention"
                    >
                    </agpr-tab>
                </agpr-tabs>
            </div>
            <div
                class="agpr-mentionWorkbenchDialog-requiredFieldContainer"
                *ngIf="selectedMentionWorkbenchTab === mentionWorkbenchTabIds.EDIT_MENTION"
            >
                <span class="agpr-mentionWorkbenchDialog-requiredField">*&nbsp;</span>
                <span class="agpr-mentionWorkbenchDialog-requiredFieldText">{{'Mention.workbench.editMention.requiredText' | localize}}</span>
            </div>

            <div
                class="agpr-mentionWorkbenchDialog-editMention"
                *ngIf="selectedMentionWorkbenchTab === mentionWorkbenchTabIds.EDIT_MENTION"
            >

                <div class="agpr-mentionWorkbenchDialog-editMention-content">
                    <agpr-scroll-panel>
                        <div class="agpr-mentionWorkbenchDialog-editMention-content-scroll">
                            <div
                                class="agpr-mentionWorkbenchDialog-header"
                            >
                                {{'Mention.workbench.editMention.content' | localize}}
                            </div>

                            @if (!editingMention?.isFinancialTimes) {
                                <!-- add tabs after we adding translation to edit mention -->
                                <div
                                    class="agpr-mentionWorkbenchDialog-contentTabs"
                                >

                                    <agpr-mention-translation-tabs
                                        *ngIf="openAiPermission"
                                        [id]="id + '_editMention_translationTabs'"
                                        [selectedTabIndex]="selectedMentionContentTab"
                                        [mention]="editingMention"
                                        (tabChanged)="tabChanged($event)"
                                        [tabsHeadingLevel]="3"
                                    ></agpr-mention-translation-tabs>
                                </div>
                                <div class="agpr-paddedContent">
                                    <agpr-mention-set-preferred
                                        [id]="id + '_editMention_setpreferrred'"
                                        [openAiPermission]="openAiPermission"
                                        [selectedTabIndex]="selectedMentionContentTab"
                                        [mention]="editingMention"
                                        [isEditMention]="true"
                                        (tabChanged)="tabChanged($event)"
                                        (preferredChanged)="checkFormState()"
                                        (translationRemoved)="checkFormState()"
                                    ></agpr-mention-set-preferred>
                                </div>

                            }
                            <div class="agpr-paddedContent">
                                <div
                                    *ngIf="selectedMentionContentTab === tabIds.ORIGINAL"
                                >
                                    <agpr-textarea-input
                                        [id]="id + '_editMention_headlineTextArea'"
                                        label="Mention.editDialog.headline.label"
                                        [required]="false"
                                        [rows]="4"
                                        [placeholder]="'Mention.editDialog.headline.placeholder' | localize"
                                        [(ngModel)]="editingMention.headline"
                                        (ngModelChange)="checkFormState()"
                                        [maxLength]='maxHeadlineCharCount'
                                    ></agpr-textarea-input>
                                    <agpr-textarea-input
                                        [id]="id + '_editMention_bodyTextArea'"
                                        label="Mention.editDialog.body.label"
                                        [required]="true"
                                        [rows]="4"
                                        [placeholder]="'Mention.editDialog.body.placeholder' | localize"
                                        [(ngModel)]="editingMention.body"
                                        [maxLength]='maxWordCount'
                                        (ngModelChange)="checkFormState()"
                                    ></agpr-textarea-input>
                                    <agpr-form-message
                                        *ngIf="showSaveErrors && !editingMention.body"
                                    >
                                        {{ 'Mention.editDialog.body.required' | localize }}
                                    </agpr-form-message>
                                    <agpr-textarea-input
                                        [id]="id + '_editMention_contextualSnippetTextArea'"
                                        label="Mention.editDialog.contextualSnippet.label"
                                        [placeholder]="'Mention.editDialog.contextualSnippet.placeholder' | localize"
                                        [(ngModel)]="editingMention.summary"
                                        [rows]="4"
                                        (ngModelChange)="checkFormState()"
                                        [maxLength]='maxWordCount'
                                    ></agpr-textarea-input>

                                </div>

                                <div [agprLoading]="!editingMention?.translation && editingMention?.translating && (selectedMentionContentTab === tabIds.TRANSLATED)"></div>

                                <ng-container *ngIf="editingMention?.translation && (selectedMentionContentTab === tabIds.TRANSLATED)">

                                    <agpr-textarea-input
                                        [id]="id + '_editMention_headlineTextArea'"
                                        label="Mention.editDialog.headline.label"
                                        [required]="false"
                                        [rows]="4"
                                        [placeholder]="'Mention.editDialog.headline.placeholder' | localize"
                                        [(ngModel)]="editingMention.translation.headline"
                                        (ngModelChange)="checkFormState()"
                                        [disabled]="editingMention?.translating"
                                        [maxLength]='maxWordCount'
                                    ></agpr-textarea-input>
                                    <agpr-textarea-input
                                        [id]="id + '_editMention_bodyTextArea'"
                                        label="Mention.editDialog.body.label"
                                        [required]="true"
                                        [rows]="4"
                                        [placeholder]="'Mention.editDialog.body.placeholder' | localize"
                                        [(ngModel)]="editingMention.translation.body"
                                        [maxLength]='maxWordCount'
                                        [disabled]="editingMention?.translating"
                                        (ngModelChange)="checkFormState()"
                                    ></agpr-textarea-input>
                                    <agpr-form-message
                                        *ngIf="showSaveErrors && !editingMention.body"
                                    >
                                        {{ 'Mention.editDialog.body.required' | localize }}
                                    </agpr-form-message>
                                    <agpr-textarea-input
                                        [id]="id + '_editMention_contextualSnippetTextArea'"
                                        label="Mention.editDialog.contextualSnippet.label"
                                        [placeholder]="'Mention.editDialog.contextualSnippet.placeholder' | localize"
                                        [(ngModel)]="editingMention.translation.summary"
                                        [rows]="4"
                                        [disabled]="editingMention?.translating"
                                        (ngModelChange)="checkFormState()"
                                        [maxLength]='maxWordCount'
                                    ></agpr-textarea-input>
                                </ng-container>

                                <div
                                    class="agpr-mentionWorkbenchDialog-header"
                                >
                                    {{'Mention.editDialog.notes.label' | localize}}
                                </div>
                                <agpr-textarea-input
                                    [id]="id + '_editMention_notesTextArea'"
                                    [placeholder]="'Mention.editDialog.notes.placeholder' | localize"
                                    [bottomMargin]="false"
                                    [rows]="4"
                                    [(ngModel)]="editingMention.note"
                                    (ngModelChange)="checkFormState()"
                                    [maxLength]='maxWordCount'
                                ></agpr-textarea-input>
                            </div>

                        </div>
                    </agpr-scroll-panel>
                </div>
                <div class="agpr-mentionWorkbenchDialog-editMention-details">
                    <agpr-scroll-panel>
                        <div class="agpr-mentionWorkbenchDialog-editMention-details-scroll">
                            <div class="agpr-mentionWorkbenchDialog-fieldGroup">
                                <div
                                    class="agpr-mentionWorkbenchDialog-header"
                                >
                                    <span>
                                        {{'Mention.workbench.organization' | localize}}
                                    </span>
                                    <agpr-button
                                        [style]="buttonTypes.icon"
                                        icon="fa-regular fa-duotone fa-gear"
                                        agprTooltip="Mention.manageMentionOrganization.gearIcon.tooltip"
                                        tooltipPosition="top"
                                        (click)="openManageMentionOrganizationDialog()"
                                    ></agpr-button>
                                </div>
                                <agpr-tags-picker
                                    [id]="id + '_editMention_tagPicker'"
                                    [(ngModel)]="editingMention.tagIds"
                                    (ngModelChange)="checkFormState()"
                                ></agpr-tags-picker>
                                <div
                                    class="agpr-mentionWorkbenchDialog-folder"
                                    [ngClass]="{'agpr-mentionWorkbenchDialog-folder--hasChips' : !!folderChips?.length}"
                                >
                                    <agpr-autocomplete
                                        [id]="id + '_editMention_metadata_selectFolder'"
                                        labelField="name"
                                        placeholder="Mention.editDialog.folder.selectFolder"
                                        [dropdown]="true"
                                        label="Mention.workbench.organization.folders"
                                        [customOptions]="folderAutocompleteOptions"
                                        [suggestions]="folderList$"
                                        [clearOnBlur]="true"
                                        [ariaLabel]="'Mention.editDialog.folder.addToFolder'"
                                        (itemSelected)="selectedFolder($event)"
                                    ></agpr-autocomplete>
                                    <div
                                        *ngIf="folderChips?.length"
                                        class="agpr-mentionWorkbenchDialog-folderChips"
                                    >
                                        <agpr-chip-container
                                            [id]="id + '_folderChipContainer'"
                                            [chips]="folderChips"
                                            (removeChip)="removeFolder($event)"
                                        ></agpr-chip-container>
                                    </div>
                                </div>
                            </div>
                            <div class="agpr-mentionWorkbenchDialog-fieldGroup">
                                <div
                                    class="agpr-mentionWorkbenchDialog-header"
                                >
                                    {{'Mention.workbench.editMention.details' | localize}}
                                </div>
                                <agpr-dropdown
                                    [id]="id + '_editMention_mediaType'"
                                    [options]="mediaTypeOptions"
                                    [(ngModel)]="selectedMediaType"
                                    (ngModelChange)="updateMediaType($event.value)"
                                    label="Mention.editDialog.mediaType.label"
                                    placeholder="Mention.editDialog.mediaType.placeholder"
                                    panelStyleClass="agpr-dropdown-panel--leftAligned"
                                ></agpr-dropdown>
                                <agpr-text-input
                                    [id]="id + '_editMention_metadata_authorText'"
                                    [label]="'Mention.editDialog.author.label'"
                                    [placeholder]="'Mention.editDialog.author.placeholder'"
                                    [(ngModel)]="editingMention.author.name"
                                    (ngModelChange)="authorChanged($event)"
                                ></agpr-text-input>
                                <agpr-text-input
                                    [id]="id + '_editMention_metadata_outletText'"
                                    [label]="'Mention.editDialog.outlet.label'"
                                    [required]="false"
                                    [placeholder]="'Mention.editDialog.outlet.placeholder'"
                                    [(ngModel)]="editingMention.publication.name"
                                    (ngModelChange)="outletChanged($event)"
                                ></agpr-text-input>
                                <agpr-autocomplete
                                    [id]="id + '_editMention_metadata_location'"
                                    class="agpr-mentionWorkbenchDialog-autocompleteLocation"
                                    labelField="displayString"
                                    label="Mention.editDialog.location.label"
                                    placeholder="Mention.editDialog.location.placeholder"
                                    [(ngModel)]="selectedLocation"
                                    [suggestionsFetcher]="regionsDataSource.searchGeographicLocations.bind(regionsDataSource)"
                                    (itemSelected)="onSelectLocation()"
                                    (clear)="onClearLocation()"
                                    [clearOnBlur]="false"
                                ></agpr-autocomplete>
                            </div>

                            <div class="agpr-mentionWorkbenchDialog-fieldGroup">
                                <div
                                    class="agpr-mentionWorkbenchDialog-label"
                                    [id]="id + '_editDialog_publishedDate_label'"
                                >
                                    {{ 'Mention.editDialog.publishedDate.label' | localize }}
                                    <span class="agpr-mentionWorkbenchDialog-requiredField" aria-hidden="true">*</span>
                                </div>
                                <div class="agpr-mentionWorkbenchDialog-fieldGroup agpr-mentionWorkbenchDialog-dateGroup">
                                    <agpr-date-picker
                                        [id]="id + '_datePicker'"
                                        [required]="true"
                                        placeholder="Mention.editDialog.publishedDate.placeholder"
                                        ariaLabelledBy="editDialog_publishedDate_label"
                                        [(ngModel)]="selectedDate"
                                        (ngModelChange)="timeOrDateChanged()"
                                    ></agpr-date-picker>
                                    <agpr-time-picker
                                        [id]="id + '_timePicker'"
                                        [ngModel]="selectedTime"
                                        (ngModelChange)="timeOrDateChanged()"
                                        [showTimezoneDisclaimer]="false"
                                        [required]="true"
                                    ></agpr-time-picker>
                                    <agpr-form-message
                                        *ngIf="showSaveErrors && !editingMention.datePublished"
                                    >
                                        {{ 'Mention.editDialog.publishedDate.required' | localize }}
                                    </agpr-form-message>
                                </div>
                            </div>

                            <div class="agpr-mentionWorkbenchDialog-fieldGroup">
                                <div
                                    class="agpr-mentionWorkbenchDialog-header"
                                >
                                    {{'Mention.workbench.editMention.additionalInfo' | localize}}
                                </div>
                                <ng-container *ngIf="selectedMediaType?.value === mediaTypeEnum.TV || selectedMediaType?.value === mediaTypeEnum.RADIO">
                                    <div
                                        class="agpr-mentionWorkbenchDialog-label"
                                    >
                                        {{ 'Mention.editDialog.duration.label' | localize }}
                                    </div>
                                    <agpr-time-picker
                                        id="editMention"
                                        [ngModel]="durationTime"
                                        [durationMode]="true"
                                        [showHour]="false"
                                        [showSecond]="true"
                                        (ngModelChange)="durationTimeChanged()"
                                        [showTimezoneDisclaimer]="false"
                                    ></agpr-time-picker>
                                </ng-container>

                                <ng-container *ngIf="!tvEyesUrlConfig.isTVEyes; else tvEyesDisplayUrl">
                                    <agpr-text-input
                                        [placeholder]="'Mention.editDialog.url.placeholder'"
                                        [id]="id + '_editMention_metadata_urlText'"
                                        [label]="'Mention.editDialog.url.label'"
                                        [isUrl]="!urlError && !!editingMention.url"
                                        [(ngModel)]="editingMention.url"
                                        (change)="urlChanged()"
                                    ></agpr-text-input>
                                    <agpr-form-message
                                        *ngIf="urlError"
                                    >
                                        {{ 'Mention.editDialog.url.error.format' | localize }}
                                    </agpr-form-message>
                                </ng-container>
                                <ng-template #tvEyesDisplayUrl>
                                    <ng-container *ngIf="tvEyesUrlConfig.viewerUrl; else tvEyesInstaPlayUrl">
                                        <agpr-text-input
                                            [placeholder]="'Mention.editDialog.url.placeholder'"
                                            [id]="id + '_editMention_metadata_urlText_viewer'"
                                            [label]="'Mention.editDialog.url.label'"
                                            [isUrl]="!!tvEyesUrlConfig.viewerUrl"
                                            [(ngModel)]="tvEyesUrlConfig.viewerUrl"
                                            [disabled]="true"
                                        ></agpr-text-input>
                                    </ng-container>
                                    <ng-template #tvEyesInstaPlayUrl>
                                        <agpr-text-input
                                            [placeholder]="'Mention.editDialog.url.placeholder'"
                                            [id]="id + '_editMention_metadata_urlText_tvEyes'"
                                            [label]="'Mention.editDialog.url.label'"
                                            [isUrl]="!!editingMention.tvEyesInstaPlayUrl"
                                            [(ngModel)]="editingMention.tvEyesInstaPlayUrl"
                                            (change)="urlChanged(true)"
                                        ></agpr-text-input>
                                        <agpr-form-message
                                            *ngIf="urlError"
                                        >
                                            {{ 'Mention.editDialog.url.error.format' | localize }}
                                        </agpr-form-message>
                                    </ng-template>
                                </ng-template>
                                <agpr-dropdown
                                    [id]="id + '_editMention_metadata_sentimentDropdown'"
                                    placeholder="Mention.editDialog.sentiment.placeholder"
                                    [options]="sentimentOptions"
                                    [(ngModel)]="selectedSentimentDropdown"
                                    (ngModelChange)="sentimentChanged($event.value)"
                                    label="Mention.editDialog.sentiment.label"
                                ></agpr-dropdown>
                                <agpr-autocomplete
                                    [id]="id + '_editMention_metadata_languageAutocomplete'"
                                    [label]="'Mention.editDialog.language.label'"
                                    [(ngModel)]="languageDropdown"
                                    [dropdown]="true"
                                    [placeholder]="'Mention.editDialog.language.placeholder'"
                                    [ariaLabel]="'Mention.editDialog.language.placeholder'"
                                    [suggestions]="languageOptions$"
                                    [forceSelection]="true"
                                    [labelField]="'label'"
                                    [style]="agprComponentStyle.social"
                                    [minLength]='1'
                                    [clearOnBlur]="false"
                                    (itemSelected)="onLanguageChange($event.value)"
                                ></agpr-autocomplete>
                                <agpr-number-input
                                    [id]="id + '_editMention_metadata_audienceReach'"
                                    label="Mention.editDialog.audienceReach.label"
                                    [min]="0"
                                    [max]="maxAudienceReach"
                                    [step]="1"
                                    [integerOnly]="true"
                                    [(ngModel)]="editingMention.audienceReach"
                                    (ngModelChange)="audienceReachChanged()"
                                ></agpr-number-input>
                                <agpr-form-message
                                    *ngIf="audienceReachError && editingMention.audienceReach < 0"
                                >
                                    {{ 'Mention.editDialog.audienceReach.error.negative' | localize }}
                                </agpr-form-message>
                                <agpr-form-message
                                    *ngIf="audienceReachError && editingMention.audienceReach > maxAudienceReach"
                                >
                                    {{ 'Mention.editDialog.audienceReach.error.exceedsMax' | localize }}
                                </agpr-form-message>

                                <agpr-number-input
                                    [id]="id + '_editMention_metadata_ave'"
                                    [label]="aveLabel"
                                    [min]="0"
                                    [max]="maxAVE"
                                    [step]="0.01"
                                    [(ngModel)]="adValueUsd"
                                    (ngModelChange)="aveChanged()"
                                    [tooltip]="'Mention.editDialog.ave.tooltip'"
                                ></agpr-number-input>
                                @if (preferredAdValue) {
                                    <span class="agpr-mentionWorkbenchDialog-field-metadata">
                                        {{ preferredAdValue }}
                                    </span>
                                }
                                <agpr-form-message
                                    *ngIf="aveError && adValueUsd < 0"
                                >
                                    {{ 'Mention.editDialog.ave.error.negative' | localize }}
                                </agpr-form-message>
                                    <agpr-form-message
                                    *ngIf="aveError && adValueUsd > maxAVE"
                                >
                                    {{ 'Mention.editDialog.ave.error.exceedsMax' | localize }}
                                </agpr-form-message>

                                <agpr-number-input
                                    [id]="id + '_editMention_metadata_wordCount'"
                                    label="Mention.editDialog.wordCount.label"
                                    [min]="0"
                                    [max]="maxWordCount"
                                    [step]="1"
                                    [(ngModel)]="editingMention.wordCount"
                                    (ngModelChange)="wordCountChanged()"
                                ></agpr-number-input>
                                <agpr-form-message
                                    *ngIf="wordCountError && editingMention.wordCount < 0"
                                >
                                    {{ 'Mention.editDialog.wordCount.error.negative' | localize }}
                                </agpr-form-message>
                                <agpr-form-message
                                    *ngIf="wordCountError && editingMention.wordCount > maxWordCount"
                                >
                                    {{ 'Mention.editDialog.wordCount.error.exceedsMax' | localize }}
                                </agpr-form-message>
                            </div>
                            <div class="agpr-mentionWorkbenchDialog-fieldGroup agpr-mentionWorkbenchDialog-imageGroup">
                                <div class="agpr-mentionWorkbenchDialog-imageGroup-headerContainer">
                                    <div
                                        class="agpr-mentionWorkbenchDialog-imageGroup-header agpr-mentionWorkbenchDialog-header"
                                    >
                                        {{'Mention.workbench.images' | localize}}
                                    </div>
                                    <div class="agpr-mentionWorkbenchDialog-imageGroup-subHeader">
                                        <div class="agpr-mentionWorkbenchDialog-imageGroup-subHeaderTitle">
                                            {{'Mention.workbench.imageSelectLimit' | localize : {maxImages: this.maxImages} }}
                                        </div>
                                        <agpr-split-button
                                            [id]="id + '_editMention_metadata_imageType'"
                                            class="agpr-mentionWorkbenchDialog-imageGroup-addButton"
                                            icon="fa-regular fa-square-plus fa-duotone"
                                            [style]="buttonTypes.icon"
                                            [options]="uploadOptions"
                                            [disabled]="editingMention.images?.length >= 10"
                                            tooltip="Discover.distribution.imageUpload.tooltip"
                                            tooltipPosition="top"
                                            [panelPositionY]="'bottom'"
                                            [panelPositionX]="'right'"
                                        ></agpr-split-button>
                                        <input
                                            #imageUpload
                                            type="file"
                                            style="display: none;"
                                            accept="image/*"
                                            (change)="onImageSelected($event)"
                                            aria-hidden="true"
                                        />
                                    </div>
                                </div>
                                <div
                                    class="agpr-mentionWorkbenchDialog-imageContainer"
                                >
                                    @if (imageValidatorModel) {
                                        <div
                                            class="agpr-mentionWorkbenchDialog-imageValidator"
                                        >
                                            <img
                                                [src]="imageValidatorModel.source"
                                                alt=""
                                                aria-hidden="true"
                                                (error)="imageFailed(imageValidatorModel)"
                                                (load)="imageLoaded(imageValidatorModel)"
                                            >
                                        </div>
                                    }
                                    @if (hasUrlImages) {
                                        <div>
                                            <span class="agpr-mentionWorkbenchDialog-imageContainer-header">{{ 'Mention.workbench.image.urlTitle' | localize }}</span>
                                            @for (image of editingMention.images; track $index) {
                                                @if (!isMediaContent(image.source)) {
                                                    <div class="agpr-mentionWorkbenchDialog-image"
                                                        [ngClass]="{ 'agpr-mentionWorkbenchDialog-image--hasError' : image.error}">
                                                        <agpr-text-input
                                                            [placeholder]="'Mention.editDialog.imageUrl.placeholder'"
                                                            [id]="id + '_editMention_metadata_image_' + $index"
                                                            [(ngModel)]="image.source"
                                                            (change)="imageChanged(image)"
                                                        ></agpr-text-input>
                                                        <div
                                                            class="agpr-mentionWorkbenchDialog-image-contextualButtons agpr-mentionWorkbenchDialog-image-contextualButtons--url"
                                                            [ngClass]="{'agpr-mentionWorkbenchDialog-image-contextualButtons--visible': previewImageIndex === $index}"
                                                        >
                                                            <agpr-button
                                                                [id]="id + '_setPreferred_' + $index"
                                                                [ngClass]="{'agpr-mentionWorkbenchDialog-image-isPreferred': image.isPreferred}"
                                                                [style]="buttonTypes.icon"
                                                                [icon]="image.isPreferred ? 'fa-solid fa-star' : 'fa-duotone fa-regular fa-star'"
                                                                [tooltip]="image.isPreferred ? 'Mentions.insightCard.preferred' : 'imageList.setAsPreferred'"
                                                                tooltipPosition="top"
                                                                (click)="setPreferredImage($index)"
                                                                [disabled]="image.isPreferred"
                                                            ></agpr-button>
                                                            <div
                                                                [agprPopover]="image.source ? imagePreviewTemplate : null"
                                                                [popoverOffsetTop]="2"
                                                                [popoverZIndex]="2"
                                                                [popoverOpenDelay]="75"
                                                                (openedPopover)="setToggledImage($index)"
                                                                (closedPopover)="setToggledImage(-1)"
                                                                (focus)="toggleImagePreview($index)"
                                                                (blur)="toggleImagePreview(-1)"
                                                            >
                                                                <agpr-button
                                                                    [id]="id + '_showImage_' + $index"
                                                                    [style]="buttonTypes.icon"
                                                                    [disabled]="!image.source"
                                                                    [icon]="'fa-regular fa-image fa-duotone'"
                                                                ></agpr-button>
                                                            </div>
                                                            <agpr-button
                                                                [id]="id + '_removeImage_' + $index"
                                                                [style]="buttonTypes.icon"
                                                                [icon]="'fa-regular fa-duotone fa-square-xmark'"
                                                                tooltip="Mention.workbench.image.removeImage"
                                                                tooltipPosition="top"
                                                                (click)="removeImage($index)"
                                                            ></agpr-button>
                                                        </div>
                                                    </div>
                                                }
                                                <ng-template #imagePreviewTemplate>
                                                    <div
                                                        class="agpr-mentionWorkbenchDialog-imageDetails"
                                                        *ngIf="image.source">
                                                        <img [src]="image.source"
                                                        alt="" class="agpr-mentionWorkbenchDialog-preview agpr-mentionWorkbenchDialog-preview--expanded">
                                                    </div>
                                                </ng-template>
                                            }
                                        </div>
                                    }
                                    @if (hasUploadedImages) {
                                        <div >
                                            <span class="agpr-mentionWorkbenchDialog-imageContainer-header agpr-library-image-header">{{ 'Mention.workbench.image.uploadedTitle' | localize }}</span>
                                            @for (image of editingMention.images; track $index) {
                                                @if (isMediaContent(image.source)) {
                                                    <div class="agpr-mentionWorkbenchDialog-uploadedImage" tabindex="0">
                                                        <div class="agpr-mentionWorkbenchDialog-uploadedImageDetails">
                                                            <img [src]="image.source"
                                                            alt="" class="agpr-mentionWorkbenchDialog-uploadedImageDetails-preview">
                                                        </div>
                                                        <span class="agpr-mentionWorkbenchDialog-uploadedImage-fileName">{{ getMediaName(image.source) }}</span>
                                                        <agpr-button
                                                            [id]="id + '_setPreferred_' + $index"
                                                            [ngClass]=" image.isPreferred ? 'agpr-mentionWorkbenchDialog-uploadedImage-isPreferred':'agpr-mentionWorkbenchDialog-uploadedImage-notPreferred'"
                                                            [style]="buttonTypes.icon"
                                                            [icon]="image.isPreferred ? 'fa-solid fa-star' : 'fa-duotone fa-regular fa-star'"
                                                            [tooltip]="image.isPreferred ? 'Mentions.insightCard.preferred' : 'imageList.setAsPreferred'"
                                                            tooltipPosition="top"
                                                            (click)="setPreferredImage($index)"
                                                            [disabled]="image.isPreferred"
                                                        ></agpr-button>
                                                        <agpr-button
                                                            [id]="id + '_removeImage_' + $index"
                                                            class="agpr-mentionWorkbenchDialog-uploadedImage-delete"
                                                            [style]="buttonTypes.icon"
                                                            [icon]="'fa-regular fa-duotone fa-square-xmark'"
                                                            tooltip="Mention.workbench.image.removeImage"
                                                            tooltipPosition="top"
                                                            (click)="removeImage($index)"
                                                        ></agpr-button>
                                                    </div>
                                                }
                                            }
                                        </div>
                                    }
                                    @if (!editingMention.images?.length) {
                                        <agpr-message
                                            [severity]="messageSeverityEnum.noContent"
                                            [useWhiteBg]="true"
                                        >
                                            {{'Mention.workbench.image.noImage' | localize}}
                                        </agpr-message>
                                    }
                                </div>
                            </div>

                            <!-- Attachments -->
                            <div
                                *ngIf="editingMention.mediaType.isSocial"
                                class="agpr-mentionWorkbenchDialog-fieldGroup"
                            >
                                <div
                                    class="agpr-mentionWorkbenchDialog-header"
                                >
                                    {{ 'Mention.workbench.editMention.engagement' | localize }}
                                </div>

                                <agpr-number-input
                                    [id]="id + '_editMention_metadata_reposts'"
                                    [label]="engagementRepostLabel"
                                    [min]="0"
                                    [max]="maxEngagement"
                                    [step]="1"
                                    [enableClamp]="false"
                                    [(ngModel)]="editingMention.share"
                                    (ngModelChange)="engagementChanged(engagementEventTypeEnum.share)"
                                ></agpr-number-input>
                                <agpr-form-message
                                    *ngIf="shareError && editingMention.share < 0"
                                >
                                    {{ 'Mention.workbench.editDialog.engagement.minError' | localize }}
                                </agpr-form-message>
                                <agpr-form-message
                                    *ngIf="shareError && editingMention.share > maxEngagement"
                                >
                                    {{ 'Mention.workbench.editDialog.engagement.maxError' | localize }}
                                </agpr-form-message>

                                <ng-container
                                    *ngIf="engagementQuoteLabel"
                                >
                                    <agpr-number-input
                                        [id]="id + '_editMention_metadata_quotes'"
                                        [label]="engagementQuoteLabel"
                                        [min]="0"
                                        [max]="maxEngagement"
                                        [step]="1"
                                        [enableClamp]="false"
                                        [(ngModel)]="editingMention.quote"
                                        (ngModelChange)="engagementChanged(engagementEventTypeEnum.quote)"
                                    ></agpr-number-input>
                                    <agpr-form-message
                                        *ngIf="quoteError && editingMention.quote < 0"
                                    >
                                        {{ 'Mention.workbench.editDialog.engagement.minError' | localize }}
                                    </agpr-form-message>
                                    <agpr-form-message
                                        *ngIf="quoteError && editingMention.quote > maxEngagement"
                                    >
                                        {{ 'Mention.workbench.editDialog.engagement.maxError' | localize }}
                                    </agpr-form-message>
                                </ng-container>


                                <agpr-number-input
                                    [id]="id + '_editMention_metadata_replies'"
                                    [label]="engagementReplyLabel"
                                    [min]="0"
                                    [max]="maxEngagement"
                                    [step]="1"
                                    [enableClamp]="false"
                                    [(ngModel)]="editingMention.reply"
                                    (ngModelChange)="engagementChanged(engagementEventTypeEnum.reply)"
                                ></agpr-number-input>
                                <agpr-form-message
                                    *ngIf="commentError && editingMention.reply < 0"
                                >
                                    {{ 'Mention.workbench.editDialog.engagement.minError' | localize }}
                                </agpr-form-message>
                                <agpr-form-message
                                    *ngIf="commentError && editingMention.reply > maxEngagement"
                                >
                                    {{ 'Mention.workbench.editDialog.engagement.maxError' | localize }}
                                </agpr-form-message>

                                <agpr-number-input
                                    [id]="id + '_editMention_metadata_likes'"
                                    [label]="engagementLikeLabel"
                                    [min]="0"
                                    [max]="maxEngagement"
                                    [step]="1"
                                    [enableClamp]="false"
                                    [(ngModel)]="editingMention.like"
                                    (ngModelChange)="engagementChanged(engagementEventTypeEnum.like)"
                                ></agpr-number-input>
                                <agpr-form-message
                                    *ngIf="likeError && editingMention.like < 0"
                                >
                                    {{ 'Mention.workbench.editDialog.engagement.minError' | localize }}
                                </agpr-form-message>
                                <agpr-form-message
                                    *ngIf="likeError && editingMention.like > maxEngagement"
                                >
                                    {{ 'Mention.workbench.editDialog.engagement.maxError' | localize }}
                                </agpr-form-message>

                                <agpr-number-input
                                    *ngIf="engagementViewLabel"
                                    [id]="id + '_editMention_metadata_views'"
                                    [label]="engagementViewLabel"
                                    [min]="0"
                                    [max]="maxEngagement"
                                    [step]="1"
                                    [enableClamp]="false"
                                    [(ngModel)]="editingMention.view"
                                    (ngModelChange)="engagementChanged(engagementEventTypeEnum.view)"
                                ></agpr-number-input>
                                <agpr-form-message
                                    *ngIf="viewError && editingMention.view < 0"
                                >
                                    {{ 'Mention.workbench.editDialog.engagement.minError' | localize }}
                                </agpr-form-message>
                                <agpr-form-message
                                    *ngIf="viewError && editingMention.view > maxEngagement"
                                >
                                    {{ 'Mention.workbench.editDialog.engagement.maxError' | localize }}
                                </agpr-form-message>

                                <agpr-number-input
                                    [id]="id + '_editMention_metadata_totalEngagement'"
                                    label="Mention.workbench.editDialog.totalEngagement"
                                    [step]="1"
                                    [disabled]="true"
                                    tooltip="Mention.workbench.editDialog.totalEngagement.tooltip"
                                    [(ngModel)]="editingMention.engagements"
                                ></agpr-number-input>
                            </div>

                            <div class="agpr-mentionWorkbenchDialog-header">
                                {{'Mention.workbench.attachments' | localize}}
                            </div>
                            <agpr-file-upload #fileUpload
                                class="agpr-mentionWorkbenchDialog-attachments"
                                [uppercaseHeader]="false"
                                [headerTooltip]="'Mention.editDialog.attachments.tooltip' | localize"
                                [maxFiles]="3"
                                [uploadButtonIcon]="'fa-regular fa-duotone fa-square-plus'"
                                [maxFileSize]="MAX_FILE_SIZE"
                                [allowFileDownload]="true"
                                [uploadButtonLabel]="''"
                                [ngModel]="files"
                                (ngModelChange)="fileUploadChange($event)"
                                [showHeaderButton]="false"
                                [showSubHeader]="true"
                                [showThumbnail]="true"
                                [uploadOptions]="uploadAttachmentOptions"
                            ></agpr-file-upload>
                            <input
                                #fileInput
                                type="file"
                                style="display: none"
                                [accept]="acceptTypes"
                                (change)="onFileSelected($event)"
                                aria-hidden="true"
                            />
                        </div>
                    </agpr-scroll-panel>
                </div>
            </div>
            <div
                *ngIf="selectedMentionWorkbenchTab === mentionWorkbenchTabIds.INSIGHTS"
                class="agpr-mentionWorkbenchDialog-insights"
            >
                <div class="agpr-mentionWorkbenchDialog-insights-main">

                    <div
                        class="agpr-mentionWorkbenchDialog-insights-main-prompt"
                    >
                        <agpr-scroll-panel>
                            <div class="agpr-mentionWorkbenchDialog-insights--promptScrollContent">
                                <div class="agpr-mentionWorkbenchDialog-insights-tabs">
                                    <agpr-tabs
                                        [selectedTabIndex]="selectedInsightTabIndex"
                                        (selectedTabIndexChange)="selectedInsightTabIndex = $event; selectedMentionInsightType = null;"
                                        [addNewTab]="'Briefings.analysis.customInsight.new.click'"
                                        (addNewTrigger)="newCustomInsight()"
                                        [addNewDisabled]="!canGenerateInsight"
                                    >
                                        @if (openAiPermission && selectedInsightTabIndex == insightTabIndex.customInsight ) {
                                            <agpr-button
                                                tabActions
                                                [id]="id + '_customInsightTab_customPrompt_button'"
                                                icon="fa-regular fa-duotone fa-gear"
                                                [style]="buttonTypes.icon"
                                                tooltip="CustomPrompt.prompt.list.section.title"
                                                (click)="openCustoPromptDialog()"
                                            ></agpr-button>
                                        }

                                        <agpr-tab
                                            [id]="id + '_insightTab'"
                                            [heading]="'Mention.workbench.insights.insights'"
                                        >
                                            @if (!selectedMentionInsightType) {
                                                <div class="agpr-mentionWorkbenchDialog-insights-main-promptTypeContainer">
                                                    <agpr-message
                                                        *ngIf="!canGenerateInsight"
                                                        [severity]="messageSeverityEnum.info"
                                                        class="agpr-data-connector-mainContent-noConnections"
                                                    >
                                                        {{ 'Mention.workbench.insights.contentLicenseLimitations' | localize }}
                                                    </agpr-message>
                                                    <ul
                                                        [id]="id + '_customInsightsList'"
                                                    >
                                                        <li
                                                            *ngFor="let item of systemInsights"
                                                            class="agpr-mentionWorkbenchDialog-insights-main-promptContainer"
                                                            (keydown.enter)="canGenerateInsight ? selectPrompt(item) : ''"
                                                            (click)="canGenerateInsight ? selectPrompt(item) : ''"
                                                        >
                                                            <agpr-prompt-card
                                                                [title]="'Mention.workbench.insights.system.' + item"
                                                                [tooltipInfo]="'Mention.workbench.insights.system.tooltip.' + item"
                                                                [disabled]="!canGenerateInsight"
                                                            >
                                                            </agpr-prompt-card>
                                                        </li>
                                                    </ul>
                                                </div>
                                            }
                                        </agpr-tab>
                                        <agpr-tab
                                            [id]="id + '_customInsightTab'"
                                            [heading]="'Mention.workbench.insights.custom'"
                                        >
                                            @if (!selectedMentionInsightType) {
                                                <div class="agpr-mentionWorkbenchDialog-insights-main-promptTypeContainer">
                                                    <agpr-message
                                                        *ngIf="!canGenerateInsight"
                                                        [severity]="messageSeverityEnum.info"
                                                    >
                                                        {{ 'Mention.workbench.insights.contentLicenseLimitations' | localize }}
                                                    </agpr-message>

                                                    @if (customInsights?.length) {
                                                        <ul
                                                            [id]="id + '_insightsList'"
                                                            agprListKeyboardNavigation
                                                            [list]="customInsights"
                                                        >
                                                            <li
                                                                *ngFor="let item of customInsights"
                                                                class="agpr-mentionWorkbenchDialog-insights-main-promptContainer"
                                                                (keydown.enter)="canGenerateInsight ? selectCustomPrompt(item) : ''"
                                                                (click)="canGenerateInsight ? selectCustomPrompt(item) : ''"
                                                            >
                                                                <agpr-prompt-card
                                                                    [title]="item.name"
                                                                    [disabled]="!canGenerateInsight"
                                                                    [canEdit]="true"
                                                                    (editPrompt)="selectCustomPrompt(item)"
                                                                    (deletePrompt)="deleteCustomPrompt(item)"
                                                                >
                                                                </agpr-prompt-card>
                                                            </li>
                                                        </ul>
                                                    } @else {
                                                        <agpr-message
                                                            [severity]="messageSeverityEnum.noContent"
                                                            class="agpr-mentionWorkbenchDialog-insights-noContent"
                                                            >
                                                            {{ 'Mention.workbench.insights.customInsights.noContent' | localize }}
                                                        </agpr-message>
                                                    }

                                                </div>
                                            }
                                        </agpr-tab>
                                    </agpr-tabs>
                                    <!-- eslint-enable @angular-eslint/template/interactive-supports-focus-->
                                </div>
                                @if (selectedMentionInsightType) {
                                    <div class="agpr-mentionWorkbenchDialog-insights-main-promptDetailContainer">
                                        <div
                                            class="agpr-mentionWorkbenchDialog-header"
                                        >
                                            <span>
                                                {{'Mention.workbench.insights.prompt' | localize}}
                                            </span>
                                        </div>
                                        <div class="agpr-mentionWorkbenchDialog-insights-main-promptHeader">
                                            <agpr-button
                                                [style]="buttonTypes.icon"
                                                [icon]="'fa-regular fa-arrow-left'"
                                                [id]="id + '_insight_backToPrompts'"
                                                (click)="backToPrompts()"
                                            ></agpr-button>
                                            @if (selectedMentionInsightType === mentionInsightTypes.CUSTOM) {
                                                <span class="agpr-mentionWorkbenchDialog-insights-main-promptHeaderText">{{ selectedCustomInsight?.id ? selectedCustomInsight?.name : 'Mention.workbench.insights.customInsights.new' | localize }}</span>
                                            } @else {
                                                <span class="agpr-mentionWorkbenchDialog-insights-main-promptHeaderText">{{ 'Mention.workbench.insights.system.' + selectedMentionInsightType | localize }}</span>
                                            }
                                        </div>
                                        @if (selectedMentionInsightType !== mentionInsightTypes.CUSTOM) {
                                            <agpr-message
                                                [severity]="messageSeverityEnum.info"
                                            >
                                                {{ 'Mention.workbench.insights.system.tooltip.' + selectedMentionInsightType | localize }}
                                            </agpr-message>
                                        }
                                        <ng-container *ngIf="!hasMentionInsightsEnabled">
                                            <agpr-mention-insight-upsell-card></agpr-mention-insight-upsell-card>
                                        </ng-container>
                                        <ng-container *ngIf="hasMentionInsightsEnabled">
                                            @if (selectedMentionInsightType !== mentionInsightTypes.CUSTOM) {
                                                <agpr-dropdown
                                                    *ngIf="selectedMentionInsightType !== mentionInsightTypes.QUOTES"
                                                    label="Common.dialog.aiHelper.language"
                                                    [options]="promptLanguageOptions"
                                                    [(ngModel)]="selectedPromptLanguageOption"
                                                    [infoCircleTooltip]="'Common.dialog.aiHelper.languageTooltip'"
                                                >
                                                </agpr-dropdown>
                                            }
                                            <div
                                                class="agpr-mentionWorkbenchDialog-insights-main-promptKeywords"
                                                *ngIf="selectedMentionInsightType === mentionInsightTypes.CONTEXTUAL_ANALYSIS || selectedMentionInsightType === mentionInsightTypes.SENTIMENT_OPINION"
                                            >
                                                <agpr-radio
                                                    [id]="id + '_insight_savedMentionKeywordContextRadio'"
                                                    label="Mention.workbench.insights.prompt.savedKeywords"
                                                    hiddenLabel="Mention.workbench.insights.prompt.savedKeywords"
                                                    [(ngModel)]="isMentionKeywords"
                                                    (ngModelChange)="validatePromptFields()"
                                                    [value]="true"
                                                ></agpr-radio>
                                                <agpr-text-input-chips
                                                    *ngIf="isMentionKeywords"
                                                    [id]="id + '_insight_savedMentionKeywordContext'"
                                                    [placeholder]="'Mention.workbench.insights.prompt.enterKeywords'"
                                                    [(ngModel)]="mentionKeywordContext"
                                                    (ngModelChange)="validatePromptFields()"
                                                ></agpr-text-input-chips>
                                                <agpr-radio
                                                    [id]="id + '_insight_manualKeywordsRadio'"
                                                    label="Mention.workbench.insights.prompt.manualKeywords"
                                                    hiddenLabel="Mention.workbench.insights.prompt.manualKeywords"
                                                    [(ngModel)]="isMentionKeywords"
                                                    [value]="false"
                                                    (ngModelChange)="validatePromptFields()"
                                                ></agpr-radio>
                                                <agpr-text-input-chips
                                                    *ngIf="!isMentionKeywords"
                                                    [id]="id + '_insight_manualKeywords'"
                                                    [placeholder]="'Mention.workbench.insights.prompt.enterKeywords'"
                                                    [(ngModel)]="manualKeywords"
                                                    (ngModelChange)="validatePromptFields()"
                                                ></agpr-text-input-chips>
                                            </div>
                                            @if (selectedMentionInsightType === mentionInsightTypes.CUSTOM) {
                                                <div class="agpr-mentionWorkbenchDialog-insights-main-custom-name">
                                                    <agpr-text-input
                                                        [id]="id + '_custom_name'"
                                                        [maxLength]="64"
                                                        [label]="'Mention.workbench.insights.prompt.custom.name'"
                                                        [placeholder]="'Mention.workbench.insights.prompt.custom.name.placeholder'"
                                                        [required]="true"
                                                        [(ngModel)]="selectedCustomInsight.name"
                                                        (ngModelChange)="customInsightFieldChanged()"
                                                    ></agpr-text-input>
                                                </div>
                                                <div class="agpr-mentionWorkbenchDialog-insights-main-custom-prompt">
                                                    <agpr-textarea-input
                                                        [id]="id + '_custom_prompt'"
                                                        [label]="'Mention.workbench.insights.prompt.custom.prompt'"
                                                        [required]="true"
                                                        [placeholder]="'Mention.workbench.insights.prompt.custom.prompt.tooltip'"
                                                        [tooltip]="'Mention.workbench.insights.prompt.custom.prompt.tooltip'"
                                                        ariaLabel="Mention.workbench.insights.prompt.custom.prompt.tooltip"
                                                        [(ngModel)]="selectedCustomInsight.prompt"
                                                        [rows]="8"
                                                        (focus)="customPromptFocused = true;"
                                                        [icon]="'fa-kit-duotone fa-agpr-ai-generic'"
                                                        (blur)="customPromptFocused = false;"
                                                        (ngModelChange)="customInsightFieldChanged()"
                                                    ></agpr-textarea-input>
                                                </div>
                                            }

                                            <div class="agpr-mentionWorkbenchDialog-insights-main-insightActions">
                                                <div class="agpr-mentionWorkbenchDialog-spacer"></div>
                                                @if (selectedMentionInsightType === mentionInsightTypes.CUSTOM) {
                                                    <agpr-button
                                                        [disabled]="!allowCustomInsightSave"
                                                        label="Mention.workbench.insights.prompt.custom.prompt.save"
                                                        [style]="buttonTypes.tertiary"
                                                        [agprTooltip]="saveCustomInsightTooltip"
                                                        [id]="id + '_custom_save'"
                                                        (click)="saveCustomInsight()"
                                                    ></agpr-button>
                                                    @if (selectedCustomInsight?.id) {
                                                        <agpr-button
                                                            [disabled]="!allowCustomInsightSave"
                                                            label="Mention.workbench.insights.prompt.custom.prompt.saveAs"
                                                            [style]="buttonTypes.tertiary"
                                                            [agprTooltip]="saveAsCustomInsightTooltip"
                                                            [id]="id + '_custom_saveAs'"
                                                            (click)="saveAsCustomInsight()"
                                                        ></agpr-button>
                                                    }
                                                }
                                                <agpr-button
                                                    *ngIf="hasGenerated"
                                                    [disabled]="!promptIsValid"
                                                    label="Mention.workbench.insights.generateInsight"
                                                    [style]="buttonTypes.tertiary"
                                                    [agprTooltip]="promptGenerateTooltip"
                                                    [id]="id + '_insight_generateInsight'"
                                                    (click)="generateInsight()"
                                                ></agpr-button>
                                                <agpr-button
                                                    *ngIf="!hasGenerated"
                                                    label="Mention.workbench.insights.stop"
                                                    [style]="buttonTypes.tertiary"
                                                    [id]="id + '_insight_stop'"
                                                    (click)="stopInsight()"
                                                ></agpr-button>
                                                <span
                                                    *ngIf="!hasGenerated"
                                                    class="loadingIndicator-area agpr-mentionWorkbenchDialog-insights-main-insightActions-loadingIndicator"
                                                    [agprLoading]="true"
                                                    [agprInlineLoadingIndicator]="true"
                                                    [loadingSmallIndicator]="true"
                                                ></span>
                                            </div>
                                        </ng-container>
                                    </div>
                                }
                            </div>
                        </agpr-scroll-panel>
                    </div>
                    <div class="agpr-mentionWorkbenchDialog-insights-main-insight">
                        <div
                            class="agpr-mentionWorkbenchDialog-insights-main-insightContainer"
                        >
                            <agpr-scroll-panel *ngIf="showInsight">
                                <div class="agpr-mentionWorkbenchDialog-insights--scrollContent">
                                    <div
                                        class="agpr-mentionWorkbenchDialog-header"
                                    >
                                        {{ (selectedMentionInsightType ? 'Mention.workbench.insights.quickInsight' : 'Mention.workbench.insights.newInsight') | localize}}
                                    </div>
                                    <agpr-text-input
                                        [placeholder]="'Mention.workbench.insights.name.placeholder'"
                                        [id]="id + '_prompt_name'"
                                        [label]="'Mention.workbench.insights.name'"
                                        [(ngModel)]="insight.name"
                                        (ngModelChange)="checkInsightState()"
                                    ></agpr-text-input>
                                    <div
                                        class="agpr-mentionWorkbenchDialog-label"
                                    >
                                        {{'Mention.workbench.insight' | localize}}
                                    </div>
                                    <div class="agpr-mentionWorkbenchDialog-insights-main-insightContent">
                                        <agpr-rich-text-editor-ck
                                            #insightEditor
                                            [richTextEditorConfig]="ckEditorConfig"
                                            [(ngModel)]="generatedInsight"
                                            (ngModelChange)="checkInsightState()"
                                        ></agpr-rich-text-editor-ck>
                                    </div>
                                    <div class="agpr-mentionWorkbenchDialog-insights-main-insightActions">
                                        <agpr-button
                                            *ngIf="generatedInsight || insight.name"
                                            [disabled]="!hasGenerated"
                                            label="Mention.workbench.insights.reset"
                                            [style]="buttonTypes.tertiary"
                                            [id]="id + '_insight_reset'"
                                            (click)="clearInsight()"
                                        ></agpr-button>
                                        <div class="agpr-mentionWorkbenchDialog-spacer"></div>
                                        <agpr-button
                                            *ngIf="!isCurrentInsightSaved"
                                            [disabled]="!generatedInsight || !insight.name || !hasGenerated || isUnsavedMention"
                                            label="Mention.workbench.insights.saveInsight"
                                            [agprTooltip]="isUnsavedMention ? 'Mention.workbench.insights.saveInsight.disabled.tooltip' : 'Mention.workbench.insights.saveInsight.tooltip'"
                                            [style]="buttonTypes.tertiary"
                                            [id]="id + '_insight_saveInsight'"
                                            (click)="saveInsight()"
                                        ></agpr-button>
                                        <agpr-split-button
                                            *ngIf="isCurrentInsightSaved"
                                            [style]="buttonTypes.tertiary"
                                            [id]="id + '_insightSaveActions'"
                                            label="Mention.insights.save"
                                            [options]="saveInsightActions"
                                            [disabled]="!isInsightDirty"
                                            [panelPositionY]="'top'"
                                            [panelPositionX]="'right'"
                                        ></agpr-split-button>
                                    </div>
                                </div>
                            </agpr-scroll-panel>
                        </div>
                        <div
                            *ngIf="!showInsight"
                            class="agpr-mentionWorkbenchDialog-insights-main-insightPlaceholder"
                        >
                            @if (customPromptFocused) {
                                <div
                                    class="agpr-mentionWorkbenchDialog-insights-main-quickTip-container"
                                >
                                    <div
                                        class="agpr-mentionWorkbenchDialog-insights-main-quickTip-header"
                                    >
                                        <span
                                            class="agpr-mentionWorkbenchDialog-insights-main-quickTip-header-icon agpr-i-light-bulb"
                                            aria-hidden="true"
                                        ></span>
                                        <h2> {{ 'Mention.workbench.insights.prompt.custom.prompt.quickTips' | localize }}</h2>
                                    </div>
                                    <ul>
                                        <li>{{ 'Mention.workbench.insights.prompt.custom.prompt.quickTips.line1' | localize }}</li>
                                        <li>{{ 'Mention.workbench.insights.prompt.custom.prompt.quickTips.line2' | localize }}</li>
                                        <li>{{ 'Mention.workbench.insights.prompt.custom.prompt.quickTips.line3' | localize }}</li>
                                    </ul>
                                </div>
                            }
                        </div>
                    </div>
                </div>
                <div class="agpr-mentionWorkbenchDialog-insights-rhp">
                    <agpr-right-sidebar
                        class="agpr-mentionWorkbenchDialog-insights-rhp-sidebar"
                        [(selectedTabIndex)]="selectedInsightRhpTabIndex"
                    >
                        <agpr-tab
                            [id]="id + '_prompt_RHP_mentionViewTab'"
                            icon="fa-file fa-md"
                            tooltip="Mention.workbench.insights.RHP.mentionView"
                        >
                            <agpr-scroll-panel>
                                <div class="agpr-mentionWorkbenchDialog-editMention-content-scroll">
                                    <div class="agpr-mentionWorkbenchDialog-header">
                                        {{'Mention.details.mentionInformation' | localize}}
                                    </div>
                                    <div class="agpr-mentionInformation-mentionInformation-metadataWrapper">
                                        @for (attribute of mentionInformation; track attribute.id) {
                                            @if (attribute.id === mentionAttributeTypesEnum.audienceReach
                                                || attribute.id === mentionAttributeTypesEnum.adValueUsd
                                                || attribute.id === mentionAttributeTypesEnum.location
                                                || (attribute?.value !== null && attribute?.value !== undefined)
                                            ) {
                                                <agpr-meta-data
                                                    class="agpr-mentionInformation-mentionInformation-metadata"
                                                    [type]="attribute.type"
                                                    [mediaType]="attribute.mediaType"
                                                    [icon]="attribute.icon"
                                                    [value]="attribute.value"
                                                    [isSimilarWeb]="attribute.isSimilarWeb"
                                                    [tooltip]="attribute.label"
                                                    [infoTooltip]="attribute.infoTooltip"
                                                    [isMultiline]="attribute.id === mentionAttributeTypesEnum.location"
                                                ></agpr-meta-data>
                                            }
                                        }
                                    </div>

                                    <div class="agpr-mentionWorkbenchDialog-header agpr-mentionWorkbenchDialog-header--mentionSection">
                                        {{'Mention.workbench.insights.RHP.mentionView.mention' | localize}}
                                    </div>
                                    <div class="agpr-mentionWorkbenchDialog-insights-rhp-mention">
                                    <a
                                        *ngIf="editingMention.isLexisNexis"
                                        href="http://www.lexisnexis.com"
                                        target="_blank"
                                    >
                                        <img
                                            src="/app/assets/images/lexisNexisFullLogo.png"
                                            [alt]="'MediaType.lexisNexis' | localize"
                                            class="agpr-mentionWorkbenchDialog-insights-rhp-mention-brandedLogo"
                                        />
                                    </a>
                                    <img
                                        *ngIf="editingMention.isBurrelles"
                                        src="/app/assets/images/burrellesIconUpdate.png"
                                        [alt]="'MediaType.burrelles.logo' | localize"
                                        class="agpr-mentionWorkbenchDialog-insights-rhp-mention-brandedLogo"
                                        agprTooltip="MediaType.burrelles"
                                        tooltipPosition="left"
                                    />
                                    <article
                                        [id]="id + '_prompt_RHP_mentionViewTab_mentionArticle'"
                                    >
                                        <div class="agpr-mentionWorkbenchDialog-insights-rhp-mentionHeadline">
                                            <span *ngIf="editingMention.headline" [innerHTML]="editingMention.headline"></span>
                                            <span *ngIf="!editingMention.headline">{{ editingMention.mediaType.noHeadlineMessage | localize }}</span>
                                        </div>
                                        <div class="agpr-mentionWorkbenchDialog-insights-rhp-mentionMetadata">
                                            <div
                                                class="agpr-mentionWorkbenchDialog-insights-rhp-mentionMetadataItem"
                                                *ngIf="editingMention.publication?.name"
                                            >
                                                <span>{{ editingMention.publication?.name }}</span>
                                            </div>

                                            <div
                                                class="agpr-mentionWorkbenchDialog-insights-rhp-mentionMetadataItem"
                                                *ngIf="editingMention.author?.name"
                                            >
                                                <span>{{ editingMention.author.name }}</span>
                                            </div>
                                            <div class="agpr-mentionWorkbenchDialog-insights-rhp-mentionMetadataItem">
                                                <span class="agpr-mentionWorkbenchDialog-insights-rhp-mentionMetadataLabel">
                                                    {{ 'Mention.workbench.insights.RHP.mentionView.mention.published' | localize }}
                                                </span>
                                                <ng-container *ngIf="preferences">
                                                    {{ editingMention.datePublished | changeTimeZone: preferences.timeZone: 'MMMM D, YYYY H:mm z' }}
                                                </ng-container>
                                            </div>
                                            <div
                                                *ngIf="editingMention.dateAvailable"
                                                class="agpr-mentionWorkbenchDialog-insights-rhp-mentionMetadataItem"
                                            >
                                                <span class="agpr-mentionWorkbenchDialog-insights-rhp-mentionMetadataLabel">
                                                    {{ 'Mention.workbench.insights.RHP.mentionView.mention.available' | localize }}
                                                </span>
                                                <ng-container *ngIf="preferences">
                                                    {{ editingMention.dateAvailable | changeTimeZone: preferences.timeZone: 'MMMM D, YYYY H:mm z' }}
                                                </ng-container>
                                            </div>
                                        </div>
                                        <section class="agpr-mentionWorkbenchDialog-insights-rhp-mentionBody">
                                            <p
                                                class="agpr-mentionWorkbenchDialog-insights-rhp-mentionParagraph"
                                                *ngFor="let paragraph of bodyParagraphs"
                                                [innerHTML]="
                                                    paragraph
                                                        | mentionLinks:editingMention.mediaType.id
                                                        | indexHighlightSup
                                                "
                                            >
                                            </p>
                                        </section>
                                        <section
                                            *ngIf="editingMention.summary"
                                            class="agpr-mentionWorkbenchDialog-insights-rhp-mentionSummaryHeading"
                                        >
                                            {{ ('Mention.details.contextualSnippet' | localize) }}
                                        </section>
                                        <section *ngIf="editingMention.summary" class="agpr-mentionWorkbenchDialog-insights-rhp-mentionSummaryBody">
                                            <p
                                                class="agpr-mentionWorkbenchDialog-insights-rhp-mentionParagraph"
                                                *ngFor="let paragraph of summaryParagraphs"
                                                [innerHTML]="
                                                    paragraph
                                                        | mentionLinks:editingMention.mediaType.id
                                                "
                                            >
                                            </p>
                                        </section>
                                        @if (editingMention?.isFinancialTimes) {
                                            <agpr-financial-times-attribution
                                                [mention]="editingMention"
                                            ></agpr-financial-times-attribution>
                                        }
                                        <ng-container *ngIf="files.length">
                                            <div class="agpr-mentionWorkbenchDialog-insights-rhp-mentionSummaryHeading">
                                                {{ ('Mention.details.attachments' | localize) }}
                                            </div>
                                            <section>
                                                <div
                                                    *ngFor="let attachment of files"
                                                >
                                                    <agpr-button
                                                        class="agpr-mentionWorkbenchDialog-insights-rhp-mentionAttachment"
                                                        [style]="buttonTypes.link"
                                                        (click)="downloadAttachment(attachment)"
                                                    >
                                                        {{ attachment.name }}
                                                    </agpr-button>
                                                </div>
                                            </section>
                                        </ng-container>
                                    </article>
                                    </div>
                                </div>
                            </agpr-scroll-panel>
                        </agpr-tab>
                        <agpr-tab
                            [id]="id + '_prompt_RHP_mentionTab'"
                            icon="fa-kit-duotone fa-agpr-insights"
                            tooltip="Mention.workbench.insights.RHP.insights"
                        >
                            <agpr-scroll-panel>
                                <div class="agpr-mentionWorkbenchDialog-editMention-content-scroll">
                                    <agpr-mention-insight-card
                                        *ngFor="let insight of editingMention.insights"
                                        [insight]="insight"
                                        (insightEdited)="updateInsight(insight)"
                                        (insightPreferred)="preferInsight(insight)"
                                        (insightDeleted)="deleteInsight(insight)"
                                    >
                                    </agpr-mention-insight-card>

                                    <agpr-message
                                        *ngIf="!editingMention?.insights?.length"
                                        class="agpr-mentionWorkbenchDialog-insights-rhp-InsightTab-noContent"
                                        [severity]="messageSeverityEnum.noContent"
                                        [useWhiteBg]="true"
                                    >
                                        <span>
                                            {{ 'Mention.workbench.insights.noContent' | localize }}
                                        </span>
                                    </agpr-message>
                                </div>
                            </agpr-scroll-panel>
                        </agpr-tab>
                    </agpr-right-sidebar>
                </div>
            </div>
        </div>

        <div
            class="agpr-mentionWorkbenchDialog-terms"
            *ngIf="!internalUser && selectedMentionWorkbenchTab === mentionWorkbenchTabIds.EDIT_MENTION"
        >
            <div class="agpr-mentionEditDialog-termsAgree">
                <agpr-checkbox
                    [id]="id + '_iAgreeCheckbox'"
                    [binary]="true"
                    [(ngModel)]="termsAccepted"
                ></agpr-checkbox>
            </div>
            <div class="agpr-mentionWorkbenchDialog-termsContent">
                {{ 'Mention.editDialog.terms.line' | localize }}&nbsp;
                <a
                    target="_blank"
                    href="https://www.agilitypr.com/agility/terms-of-use/"
                    class="agpr-mentionWorkbenchDialog-termsLink"
                >
                    {{ 'Mention.editDialog.terms.link' | localize }}
                </a>
            </div>
        </div>
    </div>

    <ng-template #takeOverFooterLeft>
        <agpr-button
            (click)="close(false)"
            [style]="buttonTypes.secondary"
            [label]="(selectedMentionWorkbenchTab === mentionWorkbenchTabIds.EDIT_MENTION ? 'Mention.workbench.actions.cancel' : 'Mention.workbench.actions.done') | localize"
        ></agpr-button>
    </ng-template>
    <ng-template #takeOverFooterRight>
        <agpr-button
            *ngIf="selectedMentionWorkbenchTab === mentionWorkbenchTabIds.EDIT_MENTION"
            (click)="save(true)"
            [disabled]="!termsAccepted || !changes || isSaving || editingMention?.translating"
            [style]="buttonTypes.primaryB"
            label="Mention.workbench.actions.saveAndClose"
        ></agpr-button>
        <agpr-button
            *ngIf="selectedMentionWorkbenchTab === mentionWorkbenchTabIds.EDIT_MENTION"
            (click)="save(false)"
            [disabled]="!termsAccepted || !changes || isSaving || editingMention?.translating"
            [style]="buttonTypes.primary"
            label="Mention.workbench.actions.saveMention"
        ></agpr-button>
    </ng-template>
</agpr-take-over-panel>
